import * as React from 'react';
import { useEffect } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { Typography, Checkbox } from '@mui/material';
import Chip from "@mui/material/Chip";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { updateLaunchtrekFile } from '../api';
import getCookie, { setTeacherCookie, userState } from '../../../Atom';
import { getAllClassbyTeacher } from '../../launchtrakflights/api'
import { useHistory } from "react-router-dom";
let newData = []
export default function EditFile(props) {
  // const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('md');
  const [checkedFiles, setCheckedFiles] = React.useState([]);
  const history = useHistory();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const inputStyle = {
    width: '100%',
    // marginTop: 2,
    "& label": {
      color: "#00000099",
      fontWeight: 500,
      fontSize: 16,
    },
    "& label.Mui-focused": {
      color: "#00000099",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#00000099",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#00000099",
      },
      // "&:hover fieldset": {
      //   borderColor: "#1A273B",
      // },
      "&.Mui-disabled fieldset": {
        borderColor: "none !important"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#00000099",
      },
      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
      },
      "& input[type=number]": {
        MozAppearance: "textfield",
      },
    },
  };
  const [expanded, setExpanded] = React.useState('panel1');
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    // border: `1px solid ${theme.palette.divider}`,
    // '&:not(:last-child)': {
    //     borderBottom: 0,
    // },
    // '&::before': {
    //     display: 'none',
    // },
  }));
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));
  const handleClose = (e) => {
    props?.setOpen(false);
    props?.setSelectedClassIds([]);
    props?.setSelectedClassNames([]);
  };
  const MuiChipCustom = styled(Chip)(() => ({
    border: "2px solid #1A273B",
    borderRadius: 4.62,
    padding: "0 14px",
    color: "#1A273B",
    backgroundColor: "#1A273B1F",
    display: "flex",
    flexDirection: "row !important",
    gap: 10,

    "& .MuiChip-label": {
      color: "#1A273B",
      fontSize: 14.03,
      display: "flex",
      alignItems: "center",
      padding: 0, // Remove padding from the label to avoid misalignment
    },

    "& .MuiChip-deleteIcon": {
      color: "#1A273B",
      fontSize: 20,
    },
  }));
  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setTeacherCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null
      })
      let hostname = window.location.host;
      window.location.assign(`${window.location.protocol}//${hostname}/teacher`)
    })
  }
  const onClassSelect = (value) => {
    // const value = event.target.value;
    const itemIndex = props?.selectedClassIds.indexOf(value?._id);
    let temp = [...props?.selectedClassIds];
    let tempName = [...props?.selectedClassNames];
    if (itemIndex >= 0) {
      temp.splice(itemIndex, 1)
      tempName.splice(itemIndex, 1)
    } else {
      temp = [...props?.selectedClassIds, value._id];
      tempName = [...props?.selectedClassNames, value.name];
    }
    props?.setSelectedClassIds(temp);
    props?.setSelectedClassNames(tempName);
    // if (itemIndex < 0) {
    //   temp.push(value?._id);
    //   tempName.push(value.name);
    //   props?.setSelectedClassIds(temp);
    //   props?.setSelectedClassNames(tempName);
    // }
  };
  const onSelectParachut=async (value)=>{
    props?.setMetaData((prevState) => ({
        ...prevState,
        noParachut: !props?.metaData?.noParachut,
    }))
    props?.setMetaData((prevState) => ({
        ...prevState,
        parachuteSize: '',
    }))
}

  const saveMetaData = () => {
    newData[props?.index] = { ...props?.metaArr[props?.index], ...props?.metaData };
    props?.setMetaArr(newData)
    props?.setOpen(false);
    props?.setSnackBarShow(true);
    props?.setSnackBarMessage("Meta Data added successfully");
    props?.setSnackBarSeverity("success");
  }
  const editMetaData = async (e) => {
    e.stopPropagation()
    const _cookie = getCookie('recoil-persist')
    if (!_cookie) {
      logoutHandler()
    } else {
      const user = _cookie ? JSON.parse(_cookie)['teacher_v1'] : {}
      const res = await updateLaunchtrekFile(props?.fileId, { ...props?.metaData, classes: props?.selectedClassIds }, user.token);
      if (res?.error) {
        if (res?.data?.statusCode == 401) {
          logoutHandler();
        }
      } else {
        props?.setSnackBarShow(true);
        props?.setSnackBarMessage("Data Edited successfully");
        props?.setSnackBarSeverity("success");
        let urlSerial = params.get('serial')
        history.push({
          pathname: '/launchtrakfiles',
          search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + 'page=' + props?.page + '&limit=' + props?.pageLimit
        })
        props?.getLaunchData(user, props?.page, props?.pageLimit)

      }
    }
    handleClose()
    props?.setMetaData({
      name: "",
      pressure: 0,
      volumeOfWater: 0,
      volumeOfEngine: 0,
      nozzleSize: 0,
      rocketDryMass: 0,
      parachuteSize: 0,
      noParachut: false,
    })
  }

  return (
    <React.Fragment>
      {/* <EditOutlinedIcon sx={{ color: props?.color, cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleClickOpen() }} /> */}
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={props?.open}
      // onClose={handleClose}
      >
        <DialogTitle>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            {/* <ArrowBackOutlinedIcon /> */}
            <Typography style={{ fontWeight: 500, fontSize: 22 }}>{props?.edit ? "Update MetaData" : "Add MetaData"}</Typography>
          </div>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton></DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 5,
              // padding: 3
            }}
          >

            <div style={{ display: 'flex', flexDirection: 'column', gap: 30, marginTop: 25 }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                <div style={{ width: '33%' }}>
                  <TextField id="outlined-basic" label="Name" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.name}
                    onChange={(e) =>
                      props?.setMetaData((prevState) => ({
                        ...prevState,
                        name: e?.target?.value,
                      }))} />
                </div>
                <div style={{ width: '33%' }}>
                  <TextField id="outlined-basic" type='number' label="Pressure in PSI" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.pressure || ''}
                    onChange={(e) =>
                      props?.setMetaData((prevState) => ({
                        ...prevState,
                        pressure: Number(e?.target?.value),
                      }))} />

                </div>
                <div style={{ width: '33%' }}>
                  <TextField id="outlined-basic" type='number' label="Volume of water in milliliters" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.volumeOfWater || ''}
                    onChange={(e) =>
                      props?.setMetaData((prevState) => ({
                        ...prevState,
                        volumeOfWater: Number(e?.target?.value),
                      }))} />

                </div>
              </div>
              {/* //SECOND DIV */}
              <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                <div style={{ width: '33%' }}>
                  <TextField id="outlined-basic" type='number' label="Volume of engine in milliliters" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.volumeOfEngine || ''}
                    onChange={(e) =>
                      props?.setMetaData((prevState) => ({
                        ...prevState,
                        volumeOfEngine: Number(e?.target?.value),
                      }))} />

                </div>
                <div style={{ width: '33%', height: '40px' }}>
                  <FormControl sx={inputStyle} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}
                    onChange={(e) =>
                      props?.setMetaData((prevState) => ({
                        ...prevState,
                        nozzleSize: Number(e?.target?.value),
                      }))}>
                    <FormLabel id="demo-radio-buttons-group-label">Nozzle size</FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue={props?.metaData?.nozzleSize}
                      name="radio-buttons-group"
                      style={{ display: 'flex', flexDirection: 'row', marginTop: -15 }}>
                      <FormControlLabel value="8" control={<Radio style={{ color: '#000000' }} />} label="8 mm" />
                      <FormControlLabel value="10" control={<Radio style={{ color: '#000000' }} />} label="10 mm" />
                      <FormControlLabel value="12" style={{ marginRight: '0px' }} control={<Radio style={{ color: '#000000' }} />} label="12mm" />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div style={{ width: '33%' }}>
                  <TextField id="outlined-basic" type='number' label="Rocket dry mass in grams" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.rocketDryMass || ''}
                    onChange={(e) =>
                      props?.setMetaData((prevState) => ({
                        ...prevState,
                        rocketDryMass: Number(e?.target?.value),
                      }))}
                  />
                </div>
              </div>
              <div style={{ width: '33%' }}>
                <TextField id="outlined-basic" type='number' disabled={props?.metaData?.noParachut} label="Parachute size in sq meters" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.parachuteSize || ''}
                  onChange={(e) =>
                    props?.setMetaData((prevState) => ({
                      ...prevState,
                      parachuteSize: Number(e?.target?.value),
                    }))}

                />

              </div>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={props?.metaData?.noParachut ? true : false}
                    // onClick={editFeatured}
                    onChange={(e) =>  onSelectParachut()}
                    style={{
                      color: "#0000004D",
                    }}
                  />
                }
                label={
                  <Typography
                    variant="subtitle1"
                    className="text-[#00000033]"
                    sx={{
                      fontWeight: 500,
                      fontSize: 16,
                      color: "#00000099",
                      fontFamily: "Inter",
                    }}
                  >
                    No parachute
                  </Typography>
                }
              />
            </div>

            {/* EDIT ASSIGNED CLASSES */}
            {props?.edit && <div>
              {/* <div style={{ backgroundColor: '#0000004F', height: '1px' }}></div> */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: 15, marginTop: 10 }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,

                  }}
                >
                  <Typography
                    variant="subtitle1"
                    className="text-[#00000033]"
                    sx={{
                      fontWeight: 400,
                      fontSize: 19,
                      fontFamily: "Inter",
                    }}
                  >
                    Assign to Classes
                  </Typography>
                  <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionDetails sx={{ padding: 0 }}>
                      {props?.allClasses?.map((item) => (

                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                          key={item?._id}
                          onClick={() => onClassSelect(item)}
                        >
                          <Checkbox
                            checked={props?.selectedClassIds?.indexOf(item?._id) > -1} />
                          <Typography variant='body2'>{item?.name}</Typography>
                        </div>
                      ))}
                    </AccordionDetails>

                  </Accordion>
                </div>
              </div></div>}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => props?.edit ? editMetaData(e) : saveMetaData(e)}
            sx={{
              width: '129px',
              height: '55px',
              borderRadius: '4.62px',
              backgroundColor: '#1A273B',
              color: '#FFFFFF',
              textTransform: 'none',
              alignItems: 'center !important',
              ":hover": { backgroundColor: '#1A273B' }
            }}
          >Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
